<form autocomplete="off" class="p-0" novalidate [formGroup]="uploadForm">
  <div class="main-content side-content pt-0 ml-0 mdu-wrapper">
    <div class="main-container container-fluid">
      <div class="inner-body">
        <div class="row row-sm add-form">
          <div class="col-lg-12 col-md-12">
            <div class="card custom-card">
              <div class="card-body pb-0">
                <div class="col-md-12 prpl">
                  <div class="row align-items-center">
                    <div class="col-md-4 prpl">
                      <div class="d-flex align-items-center">
                        <img alt="Logo" src="../../assets/img/attendance.png"
                             class="mh-45px pb-2">
                        <p class="mb-1">
                          <span class="main-content-label"><b>Marks Data Upload Sheets</b></span><br>
                          <span class="text-muted card-sub-title mb-0">
                            Upload Student Barcode &amp; Evaluation Data
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>

                  <hr class="mt-2">

                
                  <div class="row clearfix mt-2">
                    <div class="col-sm-4">
                      <div class="form-group">
                        <mat-form-field appearance="outline" class="example-full-width">
                          <mat-label>Session</mat-label>
                          <mat-select #selSession placeholder="Session" class="colorblack"
                                      formControlName="SessionId">
                            <mat-select-filter *ngIf="selSession.focused"
                                               [placeholder]="'Filter'"
                                               [displayMember]="'SnName'"
                                               [array]="sessionList"
                                               (filteredReturn)="SessionFilterList = $event">
                            </mat-select-filter>
                            <mat-option *ngFor="let item of SessionFilterList"
                                        [value]="item.SnNo"
                                        (click)="getCourse(item)">
                              {{ item.SnName }}
                            </mat-option>
                          </mat-select>
                          <mat-error *ngIf="uploadForm.get('SessionId').hasError('required')">
                            Session is required
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>

                    <div class="col-sm-4">
                      <div class="form-group">
                        <mat-form-field appearance="outline" class="example-full-width">
                          <mat-label>Course</mat-label>
                          <mat-select #selCourse class="colorblack" formControlName="course">
                            <mat-select-filter *ngIf="selCourse.focused"
                                               [placeholder]="'Filter'"
                                               [displayMember]="'CoName'"
                                               [array]="CourseList"
                                               (filteredReturn)="filteredListCourse = $event">
                            </mat-select-filter>
                            <mat-option *ngFor="let item of filteredListCourse"
                                        [value]="item.CoCode"
                                        (click)="getExamList(item)">
                              {{ item.CoCode }} - {{ item.CoName }}
                            </mat-option>
                          </mat-select>
                          <mat-error *ngIf="uploadForm.get('course').hasError('required')">
                            Course is required
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>

                    <div class="col-sm-4">
                      <div class="form-group">
                        <mat-form-field appearance="outline" class="example-full-width">
                          <mat-label>Exam</mat-label>
                          <mat-select #selExam placeholder="Exam" formControlName="EmId">
                            <mat-select-filter *ngIf="selExam.focused"
                                               [placeholder]="'Filter'"
                                               [displayMember]="'EmName'"
                                               [array]="examList"
                                               (filteredReturn)="filteredListExam = $event">
                            </mat-select-filter>
                            <mat-option *ngFor="let item of filteredListExam" [value]="item.EmId">
                              {{ item.EmCoCode }}-{{ item.EmName }}
                            </mat-option>
                          </mat-select>
                          <mat-error *ngIf="uploadForm.get('EmId').hasError('required')">
                            Exam is required
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>
                  </div>

                  <div class="row mt-2">

                    <!-- Barcode -->
                    <div class="col-md-6 mb-3">
                      <div class="upload-card h-100">
                        <div class="upload-card-header">
                          <i class="fa fa-barcode mr-2"></i>
                          <span>Student Barcode Data Upload</span>
                        </div>

                        <div class="upload-card-body">
                          <p class="text-muted small mb-3">
                            Upload an Excel sheet (.xlsx / .xls) containing student barcode data.
                          </p>

                          <div class="file-picker mb-3">
                            <input type="file"
                                   id="barcodeFileInput"
                                   class="mdu-hidden-file"
                                   accept=".xlsx,.xls,.csv"
                                   (change)="onBarcodeFileSelected($event)"
                                   [disabled]="isBarcodeUploading">

                            <div class="d-flex align-items-center">
                              <div class="file-name-box flex-grow-1"
                                   [title]="barcodeFileName || 'Choose Excel file...'">
                                {{ barcodeFileName || 'Choose Excel file...' }}
                              </div>
                              <label for="barcodeFileInput"
                                     class="btn btn-outline-secondary ml-2 mdu-browse-btn"
                                     [class.disabled]="isBarcodeUploading">
                                Browse
                              </label>
                            </div>
                          </div>

                          <button type="button"
                                  class="btn size1 btn-primary btn-icon-text mdu-upload-btn"
                                  [disabled]="isBarcodeUploading || !barcodeFile"
                                  (click)="uploadBarcodeData()">
                            <span class="d-inline-flex align-items-center">
                              <i class="fa fa-upload mr-2"></i>
                              <span *ngIf="!isBarcodeUploading">Upload Barcode Data</span>
                              <span *ngIf="isBarcodeUploading">
                                Uploading {{ barcodeCurrentRecord }} / {{ barcodeTotalRecords }}...
                              </span>
                            </span>
                          </button>

                          <div class="mt-3" *ngIf="isBarcodeUploading">
                            <div class="progress" style="height: 8px;">
                              <div class="progress-bar progress-bar-striped progress-bar-animated bg-primary"
                                   [ngStyle]="{'width': barcodeProgress + '%'}"></div>
                            </div>
                            <div class="d-flex justify-content-between mt-2 small text-muted">
                              <span>Success: <b class="text-success">{{ barcodeSuccessCount }}</b></span>
                              <span>Failed: <b class="text-danger">{{ barcodeFailCount }}</b></span>
                              <span>ETA: <b>{{ barcodeEstimatedTime }}</b></span>
                            </div>
                          </div>

                          <div class="mt-3 small" *ngIf="barcodeTotalRecords > 0 && !isBarcodeUploading">
                            <div class="text-muted">
                              Total: <b>{{ barcodeTotalRecords }}</b> &nbsp;|&nbsp;
                              Success: <b class="text-success">{{ barcodeSuccessCount }}</b> &nbsp;|&nbsp;
                              Failed: <b class="text-danger">{{ barcodeFailCount }}</b>
                            </div>
                          </div>

                          <div class="mt-3" *ngIf="barcodeShowDownload">
                            <button class="btn btn-warning btn-sm mdu-upload-btn"
                                    (click)="downloadFailedExcel('barcode')">
                              <i class="fa fa-download mr-1"></i>Download Failed Records
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="col-md-6 mb-3">
                      <div class="upload-card h-100">
                        <div class="upload-card-header">
                          <i class="fa fa-file-alt mr-2"></i>
                          <span>Evaluation Data Upload</span>
                        </div>

                        <div class="upload-card-body">
                          <p class="text-muted small mb-3">
                            Upload an Excel sheet (.xlsx / .xls) containing evaluation data.
                          </p>

                          <div class="file-picker mb-3">
                            <input type="file"
                                   id="evaluationFileInput"
                                   class="mdu-hidden-file"
                                   accept=".xlsx,.xls,.csv"
                                   (change)="onEvaluationFileSelected($event)"
                                   [disabled]="isEvaluationUploading">

                            <div class="d-flex align-items-center">
                              <div class="file-name-box flex-grow-1"
                                   [title]="evaluationFileName || 'Choose Excel file...'">
                                {{ evaluationFileName || 'Choose Excel file...' }}
                              </div>
                              <label for="evaluationFileInput"
                                     class="btn btn-outline-secondary ml-2 mdu-browse-btn"
                                     [class.disabled]="isEvaluationUploading">
                                Browse
                              </label>
                            </div>
                          </div>

                          <button type="button"
                                  class="btn size1 btn-primary btn-icon-text mdu-upload-btn"
                                  [disabled]="isEvaluationUploading || !evaluationFile"
                                  (click)="uploadEvaluationData()">
                            <span class="d-inline-flex align-items-center">
                              <i class="fa fa-upload mr-2"></i>
                              <span *ngIf="!isEvaluationUploading">Upload Evaluation Data</span>
                              <span *ngIf="isEvaluationUploading">
                                Uploading {{ evaluationCurrentRecord }} / {{ evaluationTotalRecords }}...
                              </span>
                            </span>
                          </button>

                          <div class="mt-3" *ngIf="isEvaluationUploading">
                            <div class="progress" style="height: 8px;">
                              <div class="progress-bar progress-bar-striped progress-bar-animated bg-primary"
                                   [ngStyle]="{'width': evaluationProgress + '%'}"></div>
                            </div>
                            <div class="d-flex justify-content-between mt-2 small text-muted">
                              <span>Success: <b class="text-success">{{ evaluationSuccessCount }}</b></span>
                              <span>Failed: <b class="text-danger">{{ evaluationFailCount }}</b></span>
                              <span>ETA: <b>{{ evaluationEstimatedTime }}</b></span>
                            </div>
                          </div>

                          <div class="mt-3 small" *ngIf="evaluationTotalRecords > 0 && !isEvaluationUploading">
                            <div class="text-muted">
                              Total: <b>{{ evaluationTotalRecords }}</b> &nbsp;|&nbsp;
                              Success: <b class="text-success">{{ evaluationSuccessCount }}</b> &nbsp;|&nbsp;
                              Failed: <b class="text-danger">{{ evaluationFailCount }}</b>
                            </div>
                          </div>

                          <div class="mt-3" *ngIf="evaluationShowDownload">
                            <button class="btn btn-warning btn-sm mdu-upload-btn"
                                    (click)="downloadFailedExcel('evaluation')">
                              <i class="fa fa-download mr-1"></i>Download Failed Records
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>

                  <div class="row mt-2 mdu-actions-row">
                    <div class="col-md-12 d-flex justify-content-end align-items-center flex-wrap">

                    
                      <button type="button"
                              class="btn btn-primary mdu-action-btn mr-2"
                              [disabled]="isProcessing || isReporting || isFinalSubmitting || !isActionReady()"
                              (click)="processData()">
                        <span class="d-inline-flex align-items-center">
                          <i class="fa fa-cogs mr-2"></i>
                          <span *ngIf="!isProcessing">Process</span>
                          <span *ngIf="isProcessing">
                            <i class="fa fa-spinner fa-spin mr-1"></i>Processing...
                          </span>
                        </span>
                      </button>

                     
                      <button type="button"
                              class="btn btn-primary mdu-action-btn mr-2"
                              [disabled]="isProcessing || isReporting || isFinalSubmitting || !isActionReady()"
                              (click)="downloadReport()">
                        <span class="d-inline-flex align-items-center">
                          <i class="fa fa-file-text-o mr-2"></i>
                          <span *ngIf="!isReporting">Evaluation Report</span>
                          <span *ngIf="isReporting">
                            <i class="fa fa-spinner fa-spin mr-1"></i>Downloading...
                          </span>
                        </span>
                      </button>
                        <button type="button"
                              class="btn btn-primary mdu-action-btn mr-2"
                              [disabled]="isProcessing || isReporting || isFinalSubmitting || !isActionReady()"
                              (click)="downloadReport1()">
                        <span class="d-inline-flex align-items-center">
                          <i class="fa fa-file-text-o mr-2"></i>
                          <span *ngIf="!isReporting">Zero Marks Report</span>
                          <span *ngIf="isReporting">
                            <i class="fa fa-spinner fa-spin mr-1"></i>Downloading...
                          </span>
                        </span>
                      </button>
                      <button type="button"
                              class="btn btn-primary mdu-action-btn"
                              [disabled]="isProcessing || isReporting || isFinalSubmitting || !isActionReady()"
                              (click)="finalSubmit()">
                        <span class="d-inline-flex align-items-center">
                          <i class="fa fa-check-circle mr-2"></i>
                          <span *ngIf="!isFinalSubmitting">Final Submit</span>
                          <span *ngIf="isFinalSubmitting">
                            <i class="fa fa-spinner fa-spin mr-1"></i>Submitting...
                          </span>
                        </span>
                      </button>

                    </div>
                  </div>

                </div> 
              </div> 
            </div> 
          </div> 
        </div> 


        <!-- <div class="row row-sm" *ngIf="isBarcodeUploading || barcodeLogs.length > 0">
          <div class="col-lg-12 col-md-12">
            <div class="card custom-card border shadow-sm mt-3 logs-panel-card">
              <div class="card-header bg-dark text-white d-flex justify-content-between align-items-center">
                <div>
                  <h6 class="mb-0">
                    <i class="fa fa-list-alt mr-2"></i>Barcode Upload Logs
                  </h6>
                  <small class="text-light">Live processing status</small>
                </div>
                <div class="d-flex align-items-center">
                  <span class="badge badge-success mr-2">
                    <i class="fa fa-check mr-1"></i>{{ barcodeLogsSuccessCount }}
                  </span>
                  <span class="badge badge-danger mr-2">
                    <i class="fa fa-times mr-1"></i>{{ barcodeLogsFailCount }}
                  </span>
                  <button class="btn btn-sm mdu-upload-btn btn-outline-light mr-2"
                          (click)="clearLogs('barcode')"
                          [disabled]="barcodeLogs.length === 0">
                    <i class="fa fa-trash mr-1"></i> Clear
                  </button>
                  <span class="badge badge-light">{{ barcodeLogs.length }} logs</span>
                </div>
              </div>
              <div class="card-body p-0 logs-panel-body">
                <div class="logs-container" #barcodeLogsContainer>
                  <div class="text-center py-5 text-muted" *ngIf="barcodeLogs.length === 0">
                    <i class="fa fa-spinner fa-spin fa-2x mb-3"></i>
                    <p>Waiting for upload to start...</p>
                  </div>
                  <div class="log-entry"
                       *ngFor="let log of barcodeLogs; let i = index"
                       [ngClass]="{
                         'log-success': log.result === true,
                         'log-error': log.result === false,
                         'log-info': log.result === null
                       }">
                    <div class="log-header">
                      <div class="log-icon">
                        <i class="fa" [ngClass]="{
                             'fa-check-circle': log.result === true,
                             'fa-times-circle': log.result === false,
                             'fa-info-circle': log.result === null
                           }"></i>
                      </div>
                      <div class="log-info">
                        <div class="log-prn">
                          <strong>PRN:</strong>
                          <span class="prn-number">{{ log.prnNo || 'N/A' }}</span>
                        </div>
                        <div class="log-time">
                          <i class="fa fa-clock-o mr-1"></i>{{ log.timestamp | date:'HH:mm:ss' }}
                        </div>
                      </div>
                      <div class="log-status">
                        <span class="badge" [ngClass]="{
                                'badge-success': log.result === true,
                                'badge-danger': log.result === false,
                                'badge-info': log.result === null
                              }">
                          {{ log.result === true ? 'SUCCESS' : (log.result === false ? 'FAILED' : 'INFO') }}
                        </span>
                      </div>
                    </div>
                    <div class="log-message" *ngIf="log.message">
                      <i class="fa fa-comment-o mr-2"></i><span>{{ log.message }}</span>
                    </div>
                    <div class="log-details" *ngIf="log.details">
                      <button class="btn btn-link btn-sm p-0 mdu-link-btn"
                              (click)="toggleLogDetails('barcode', i)">
                        <i class="fa" [ngClass]="log.expanded ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                        {{ log.expanded ? 'Hide' : 'Show' }} Details
                      </button>
                      <div class="details-content" *ngIf="log.expanded">
                        <pre>{{ log.details | json }}</pre>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-footer bg-light border-top">
                <div class="d-flex justify-content-between align-items-center">
                  <small class="text-muted">
                    <i class="fa fa-circle text-success blink"></i> Live Updates
                  </small>
                  <label class="mb-0">
                    <input type="checkbox" [(ngModel)]="barcodeAutoScroll" class="mr-1">Auto-scroll
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div> -->


        <!-- <div class="row row-sm" *ngIf="isEvaluationUploading || evaluationLogs.length > 0">
          <div class="col-lg-12 col-md-12">
            <div class="card custom-card border shadow-sm mt-3 logs-panel-card">
              <div class="card-header bg-dark text-white d-flex justify-content-between align-items-center">
                <div>
                  <h6 class="mb-0">
                    <i class="fa fa-list-alt mr-2"></i>Evaluation Upload Logs
                  </h6>
                  <small class="text-light">Live processing status</small>
                </div>
                <div class="d-flex align-items-center">
                  <span class="badge badge-success mr-2">
                    <i class="fa fa-check mr-1"></i>{{ evaluationLogsSuccessCount }}
                  </span>
                  <span class="badge badge-danger mr-2">
                    <i class="fa fa-times mr-1"></i>{{ evaluationLogsFailCount }}
                  </span>
                  <button class="btn btn-sm mdu-upload-btn btn-outline-light mr-2"
                          (click)="clearLogs('evaluation')"
                          [disabled]="evaluationLogs.length === 0">
                    <i class="fa fa-trash mr-1"></i> Clear
                  </button>
                  <span class="badge badge-light">{{ evaluationLogs.length }} logs</span>
                </div>
              </div>
              <div class="card-body p-0 logs-panel-body">
                <div class="logs-container" #evaluationLogsContainer>
                  <div class="text-center py-5 text-muted" *ngIf="evaluationLogs.length === 0">
                    <i class="fa fa-spinner fa-spin fa-2x mb-3"></i>
                    <p>Waiting for upload to start...</p>
                  </div>
                  <div class="log-entry"
                       *ngFor="let log of evaluationLogs; let i = index"
                       [ngClass]="{
                         'log-success': log.result === true,
                         'log-error': log.result === false,
                         'log-info': log.result === null
                       }">
                    <div class="log-header">
                      <div class="log-icon">
                        <i class="fa" [ngClass]="{
                             'fa-check-circle': log.result === true,
                             'fa-times-circle': log.result === false,
                             'fa-info-circle': log.result === null
                           }"></i>
                      </div>
                      <div class="log-info">
                        <div class="log-prn">
                          <strong>PRN:</strong>
                          <span class="prn-number">{{ log.prnNo || 'N/A' }}</span>
                        </div>
                        <div class="log-time">
                          <i class="fa fa-clock-o mr-1"></i>{{ log.timestamp | date:'HH:mm:ss' }}
                        </div>
                      </div>
                      <div class="log-status">
                        <span class="badge" [ngClass]="{
                                'badge-success': log.result === true,
                                'badge-danger': log.result === false,
                                'badge-info': log.result === null
                              }">
                          {{ log.result === true ? 'SUCCESS' : (log.result === false ? 'FAILED' : 'INFO') }}
                        </span>
                      </div>
                    </div>
                    <div class="log-message" *ngIf="log.message">
                      <i class="fa fa-comment-o mr-2"></i><span>{{ log.message }}</span>
                    </div>
                    <div class="log-details" *ngIf="log.details">
                      <button class="btn btn-link btn-sm p-0 mdu-link-btn"
                              (click)="toggleLogDetails('evaluation', i)">
                        <i class="fa" [ngClass]="log.expanded ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                        {{ log.expanded ? 'Hide' : 'Show' }} Details
                      </button>
                      <div class="details-content" *ngIf="log.expanded">
                        <pre>{{ log.details | json }}</pre>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-footer bg-light border-top">
                <div class="d-flex justify-content-between align-items-center">
                  <small class="text-muted">
                    <i class="fa fa-circle text-success blink"></i> Live Updates
                  </small>
                  <label class="mb-0">
                    <input type="checkbox" [(ngModel)]="evaluationAutoScroll" class="mr-1">Auto-scroll
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div> -->

      </div>
    </div> 
  </div> 
</form>